import React, { useState } from 'react'
import styled from 'styled-components'
import AcceptIcon from '../../../../../generic/icons/IconLib/CheckIcon'
import BasketIcon from '../../../../../generic/icons/IconLib/BasketIcon'
import CloseIcon from '../../../../../generic/icons/IconLib/XIcon'
import EditIcon from '../../../../../generic/icons/IconLib/PencilIcon'
import ErrorIcon from '../../../../../generic/icons/IconLib/AlertCircleIcon'
import InvoiceIcon from '../../../../../generic/icons/IconLib/InvoiceIcon'
import PackageIcon from '../../../../../generic/icons/IconLib/PackageBoxIcon'
import PalletIcon from '../../../../../generic/icons/IconLib/PalletIcon'
import PrintIcon from '../../../../../generic/icons/IconLib/PrintIcon'
import ScalesIcon from '../../../../../generic/icons/IconLib/ScaleIcon'
import SpeedIcon from '../../../../../generic/icons/IconLib/TruckIcon'
import PaperclipIcon from '../../../../../generic/icons/IconLib/PaperclipIcon'
import CheckCircleIcon from '../../../../../generic/icons/IconLib/CheckCircleIcon'
import KbdChipButton from '../../../../../generic/ui/KbdChipButton/KbdChipButton'
import { IOrderItem } from '../../../../../modules/API/Drivers/models/kavData'
import { getDriverStatusColor, getTextFromDriverStatus } from '../../teudotProblems/hooks/useProblemHelpers'
import StatusReturningBadge from '../Components/StatusReturningBadge'

interface IProps extends IOrderItem {
    printFunc?: (CODE: number, SUBCODE: number) => void,
    isNotMain?: boolean,
    handleSelectOrder?: (item: IOrderItem) => void
    item: IOrderItem,
    openPhotoUpload?: (entityType: number, entityId: number) => void,
    isPhotoUploaded?: (entityType: number, entityId: number) => boolean
    // handleSelectProblem?: (orderID: number) => void
}
interface Ibutton {
    $isDisabled?: boolean;
    $Status?: number;
}

const OrderItem = ({
    Delivery_Num, Delivery_Sub, OrderID, Pallets, 
    DeliveryStat, handleSelectOrder, DriverStatus,
    Packs, Weight, PalletsList, printFunc, IsProblem,
    isNotMain, GroupDesc, Selected, item, DistributNote,
    openPhotoUpload, isPhotoUploaded
    // handleSelectProblem
}: IProps) => {
    const [isOpen, setIsOpen] = useState<boolean>(false)

    const isTeuda = Delivery_Num !== 0
    const isDelivered = item.LastAction?.Action === 1
    const isExistProblem = item.LastAction?.Action > 1
    const palletsQty = PalletsList.length > 0 ? PalletsList.reduce((acc, cur) => acc + cur.PallQty, 0) : Pallets
    // Entity type 1 is the teuda; orders without one are addressed by OrderID.
    const photoEntityId = Delivery_Num || OrderID
    const hasPhoto = isPhotoUploaded ? isPhotoUploaded(1, photoEntityId) : false

    const handlePhotoClick = (e: React.MouseEvent) => {
        e.stopPropagation()
        openPhotoUpload?.(1, photoEntityId)
    }
    
    // const handleSelectProblemForModal = () => {
    //     if(!handleSelectProblem || !IsProblem || DriverStatus !== 0) return
    //     handleSelectProblem(OrderID)
    // }

    const handlePrint = (e: React.MouseEvent) => {
        if(!Delivery_Num) return
        e.stopPropagation()
        if(printFunc) {
            printFunc(+Delivery_Num, +Delivery_Sub)
        }
    }

    const handleTogglePalletList = (e: React.MouseEvent) => {
        e.stopPropagation()
        setIsOpen(!isOpen)
        handleSelect(e)
    }
    const handleSelect = (e: React.MouseEvent) => {
        e.stopPropagation()
        if(!handleSelectOrder) return
        handleSelectOrder(item)
    }

    const colorForItem = () => {
        if(isDelivered) {
            return '#297F76'
        } else if(isExistProblem) {
            return 'tomato'
        } else {
            return ''
        }
    }

  return (
    <MainWrapper onClick={handleTogglePalletList} $customBG={colorForItem()}>
        <SideIndicator $color={isDelivered ? '#297F76' : 'tomato'}>
           
            {
                isNotMain && Selected ?
                    <AcceptIcon /> : ''
            }
            {
                    Delivery_Num && !isNotMain ?
                        <ButtonSide
                        
                            onClick={handlePrint}
                        >
                            <PrintIcon/>
                        </ButtonSide>  :
                        !isNotMain && isTeuda && isDelivered ?
                            <AcceptIcon /> : isTeuda && isExistProblem && !isNotMain?
                            <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={() => {}}><CloseIcon /></span> : ''
            }
            {
                !isNotMain && openPhotoUpload &&
                    <PhotoButton
                        variant={hasPhoto ? 'accent' : 'default'}
                        onClick={handlePhotoClick}
                        aria-label='העלאת תמונה או הערה'
                        title='העלאת תמונה או הערה'
                    >
                        {hasPhoto ? <CheckCircleIcon /> : <PaperclipIcon />}
                    </PhotoButton>
            }
            {/* {
                IsProblem &&
                <ButtonSide
                    Status={DriverStatus}
                    onClick={handleSelectProblemForModal}
                >
                    <ErrorIcon />
                </ButtonSide>
            } */}
        </SideIndicator>
        
        <ContenWrapper>
            <Title>
                    <TitleItem>
                        {Delivery_Num ? Delivery_Num : 'לא קיימת תעודה'}
                        <InvoiceIcon />
                    </TitleItem> 
                
                
                <TitleItem>
                    {OrderID}
                    <span style={{ display: 'inline-flex', cursor: 'pointer' }} onClick={() => {}}><BasketIcon /></span>
                </TitleItem>
            </Title>
            <Title>
                <TitleItem>
                    {palletsQty?.toFixed(2)} 
                    <PalletIcon />
                </TitleItem>
                <TitleItem>
                    {GroupDesc?.trim()}
                </TitleItem>
                {
                    IsProblem &&
                    <StatusReturningBadge status={DriverStatus} />
                }
            </Title>
            <Title>
                {
                    DistributNote.trim() && (
                        <TitleItem
                            $isMarked
                        >
                            {DistributNote.trim()}
                            <EditIcon />
                        </TitleItem>
                    )
                }
            </Title>
            {
                isOpen && PalletsList.length > 0 && !isNotMain &&
                    <BodyWrapper>
                        {
                            PalletsList.map((item, index) => 
                                <Title key={index}>
                                    <TitleItem>
                                        {Math.round(item.Gross)}
                                        <ScalesIcon />
                                    </TitleItem>
                                    <TitleItem>
                                        {item.Qty}
                                        <PackageIcon />
                                    </TitleItem>
                                    <TitleItem>
                                        {item.Pallet_Num} - 
                                        <PalletIcon />
                                    </TitleItem>
                                </Title>
                            )
                        }
                    </BodyWrapper>
            }
        </ContenWrapper>
    </MainWrapper>
  )
}
const MainWrapper = styled.div<{$customBG?: string}>`
position: relative;
    width: 100%;
    background: ${props => props.$customBG ? props.$customBG : '#e9f0f0'} ;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    padding: 0.5em;
    color: ${props => props.$customBG ? '#fff' : '#838484'} ;
    cursor: pointer;
    svg {
        transition: 0.3s ease-in-out;
        color: ${props => props.$customBG ? '#ffff' : '#7ab0ab'} ;
        /* color: #7ab0ab; */
    }
`
const ContenWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-flow: column;
    gap: 0.5em;
`
const Title = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 1em;
`
const TitleItem = styled.div<{$isMarked?: boolean}>`
    display: flex;
    gap: 0.3em;
    color: ${props => props.$isMarked ? 'tomato' : ''};
    svg {
        color: ${props => props.$isMarked ? 'tomato' : ''};
    }
`
const Kwuca = styled.div<{$isKwuca?: boolean}>`
    background: ${props => props.$isKwuca ? '' : ''}
`
const BodyWrapper = styled.div`
    padding: 1em 0;
    border-top: 2px solid #7ab0ab;
    display: flex;
    flex-flow: column;
    gap: 0.5em;

`
const ButtonSide = styled.div<Ibutton>`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: ${props => props.$Status === 0 ? '' : "#2e8078"};
    opacity: ${props => props.$isDisabled ? '0.4' : '1'};
    cursor: ${props => props.$isDisabled ? 'default': 'pointer'};   
   
    &:hover {
        svg {
            color:#297F76;
        }
    }
    @media screen and (max-width: 400px) {
        min-width: 2em
    }
`
const SideIndicator = styled.div<{$color?: string}>`
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 1em;
    padding: 0.5em;
    /* width: 2em; */
    /* height: 2em;
     */
    gap: 0.5em;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    border-radius: 10px;
    svg {
        color: ${props => props.$color ? props.$color : '#7ab0ab'};
    }
    /* background: #7ab0ab;
    border-radius: 20px 0 0 20px; */

`
// SideIndicator paints every nested svg by delivery status; the photo button
// keeps its own design-system colors.
const PhotoButton = styled(KbdChipButton)`
    && svg {
        color: currentColor;
    }
`
const DriverStatusBadge = styled.div<{$color?: string}>`
    background: ${props => props.$color ? props.$color : '#7ab0ab'};
    color: #fff;
    padding: 0.2em 0.5em;
    border-radius: 10px;
    
`
export default OrderItem